<template>
  <a
    class="category-banner"
    :href="getBannerData(data, ['body', 'url'])"
    :target="getBannerData(data, ['body', 'target'])"
    @click="onClick"
  >
    <img
      class="category-banner__backgound-img"
      :src="getBannerData(data, ['body','image'])"
      :alt="getBannerData(data, ['body','alt'])"
    >
    <span class="category-banner__caption">
      {{ getBannerData(data, ['text','title']) }}
    </span>
  </a>
</template>

<script>
import objectPath from 'object-path';
import { createGtmEventsProxy } from '@/gtm/gtm-events-utils';
import { bannersGtmEvents } from '@/gtm/banners-gtm-events';

export default {
  name: 'category-banner',

  inject: {
    gtmEvents: {
      default: createGtmEventsProxy(bannersGtmEvents),
    },
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
    slotName: {
      type: String,
      default: '',
    }
  },

  mounted() {
    if (!this.slotName) return;
    this.gtmEvents.showBanner({
      slotName: this.slotName,
      imageUrl: this.getBannerData(this.data, ['body', 'image']),
      redirectUrl: this.getBannerData(this.data, ['body', 'url']),
    });
  },

  methods: {
    getBannerData(bannerData, path = []) {
      return objectPath.get(bannerData.content.desktop, path);
    },

    onClick() {
      if (!this.slotName) return;
      this.gtmEvents.clickBanner({
        slotName: this.slotName,
        imageUrl: this.getBannerData(this.data, ['body', 'image']),
        redirectUrl: this.getBannerData(this.data, ['body', 'url']),
      });
    },
  },
}
</script>

<style lang="scss">
  .category-banner {
    position: relative;
    background-color: #f7f7f7;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;

    @include breakpoint("tablet") {
      flex-direction: column;
    }

    &__backgound-img {
      max-width: 50%;
      height: auto;
      margin-left: 16px;
      height: 144px;

      @include breakpoint("tablet") {
        height: auto;
        max-width: 100%;
        margin: 0;
        padding: 0 20px;
      }

      @include breakpoint("desktop") {
        padding: 0 29px;
      }
    }

    &__caption {
      font-size: 16px;
      font-weight: 600;
      font-family: Gilroy, sans-serif;
      line-height: 24px;
      color: $black;
      text-align: left;
      word-break: break-word;
      width: 50%;
      margin-right: 16px;

      @include breakpoint("tablet") {
        width: 100%;
        margin: 0 0 32px 0;
        padding: 0 20px;
        text-align: center;
        font-size: 16px;
        line-height: 24px;
      }

      @include breakpoint("desktop") {
        margin: 0 0 40px 0;
        padding: 0 29px;
        font-size: 20px;
        line-height: 28px;
      }
    }
  }
</style>
